import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartSolid, faComments } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import './ClubsPage.css';

const ClubCardContainer = ({
  club,
  selected,
  onCardClick,
  onLikeClick,
  onImageClick,
  liked,
  onChatClick
}) => {
  return (
    <div className="bottom-sheet-club-container">
      <div 
        className={`bottom-sheet-card${selected ? ' selected' : ''}`}
        onClick={() => onCardClick && onCardClick(club)}
        id={`club-${club.id}`}
      >
        {/* 카드 헤더 */}
        <div className="bottom-sheet-card-header">
          <h3 className="bottom-sheet-card-title">{club.name}</h3>
          <p className="bottom-sheet-card-category">{club.location}</p>
          <p className="bottom-sheet-card-status">
            {club.operatingStatus}
            {club.operatingTime && ` · ${club.operatingTime}`}
          </p>
          <p className="bottom-sheet-card-genres">
            {club.genreList && club.genreList.length > 0 ? club.genreList.join(' · ') : '장르 정보 없음'}
          </p>
        </div>

        {/* 이미지 갤러리 */}
        <div className="bottom-sheet-card-images">
          {club.images && club.images.length > 0 ? (
            club.images.map((image, index) => (
              <div key={index} className="bottom-sheet-card-image">
                <img
                  src={image}
                  alt={`${club.name} ${index + 1}`}
                  onClick={e => { e.stopPropagation(); onImageClick && onImageClick(club.images, index); }}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))
          ) : (
            <div className="bottom-sheet-card-image">
              <img src="/Images/default-club.jpg" alt="기본 이미지" />
            </div>
          )}
        </div>

        {/* 액션 버튼들 */}
        <div className="bottom-sheet-card-actions">
          {/* 채팅 버튼 */}
          <button
            className="bottom-sheet-card-chat"
            onClick={e => { e.stopPropagation(); onChatClick && onChatClick(e, club); }}
            title="채팅"
          >
            <FontAwesomeIcon icon={faComments} />
          </button>
          {/* 북마크 버튼 */}
          <button
            className="bottom-sheet-card-bookmark"
            onClick={e => { e.stopPropagation(); onLikeClick && onLikeClick(club.id); }}
            title="찜하기"
          >
            <FontAwesomeIcon icon={liked ? faHeartSolid : faHeartRegular} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClubCardContainer; 